import React from 'react';
import { Link } from 'react-router-dom';
import { Search, BadgeCheck, Users, ArrowRight, Scale, Building2 } from 'lucide-react';

/**
 * Compact promo card linking buyers/sellers/tenants to the Professional Directory.
 * Drop this into any dashboard or landing section.
 */
const FindProfessionalPromo = ({ country = 'UK', compact = false, dataTestId = 'find-pro-promo' }) => {
  if (compact) {
    return (
      <Link to={`/find-a-professional?country=${country}`}
        className="flex items-center justify-between p-4 bg-white border border-slate-200 hover:border-[#E07A3A]/60 hover:shadow-sm transition-all group"
        data-testid={dataTestId}>
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-[#FEF3EC] border border-[#E07A3A]/30 flex items-center justify-center">
            <Search className="h-5 w-5 text-[#E07A3A]" />
          </div>
          <div>
            <p className="text-sm font-semibold text-[#0F172A]">Need a solicitor, surveyor or agent?</p>
            <p className="text-xs text-slate-500">Browse the verified directory in your country &amp; city.</p>
          </div>
        </div>
        <ArrowRight className="h-4 w-4 text-slate-400 group-hover:text-[#E07A3A] group-hover:translate-x-1 transition-all" />
      </Link>
    );
  }

  return (
    <div className="bg-[#0F172A] text-white p-6 sm:p-8 flex flex-col sm:flex-row items-start sm:items-center gap-5 sm:gap-8" data-testid={dataTestId}>
      <div className="flex-shrink-0 flex items-center gap-3">
        <div className="flex -space-x-2">
          <div className="w-10 h-10 bg-[#E07A3A] flex items-center justify-center border-2 border-[#0F172A]"><Scale className="h-4 w-4 text-white" /></div>
          <div className="w-10 h-10 bg-amber-500 flex items-center justify-center border-2 border-[#0F172A]"><Building2 className="h-4 w-4 text-white" /></div>
          <div className="w-10 h-10 bg-emerald-500 flex items-center justify-center border-2 border-[#0F172A]"><BadgeCheck className="h-4 w-4 text-white" /></div>
        </div>
      </div>
      <div className="flex-1">
        <p className="text-[10px] tracking-[0.2em] uppercase text-[#E07A3A] font-bold mb-1.5">Find a Professional</p>
        <p className="font-['Playfair_Display'] text-xl sm:text-2xl text-white mb-1.5 leading-tight">Verified agents, solicitors, surveyors & more — in your city.</p>
        <p className="text-white/60 text-xs sm:text-sm">Every professional is ID-verified and licence-checked with their statutory body.</p>
      </div>
      <Link to={`/find-a-professional?country=${country}`}
        className="inline-flex items-center gap-2 bg-[#E07A3A] text-white hover:bg-[#C4652E] px-5 py-3 text-sm font-semibold flex-shrink-0" data-testid={`${dataTestId}-cta`}>
        Browse directory <ArrowRight className="h-4 w-4" />
      </Link>
    </div>
  );
};

export default FindProfessionalPromo;
